import aT from '../const/action-type'

export default () => {
  return { type: aT.RESET_ERRORS }
}
